export default __webpack_public_path__ + "static/apple-44a210ca959d98dc2e521c9389087f41.png";